import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import styled from 'styled-components'
import { colors } from '../../../constants'

const Wrapper = styled.div`
    padding-top: 1px;

    ${({ inline }) => (inline ? 'display: inline-flex;' : 'display: flex;')}
    ${({ column }) => (column ? `flex-direction: column;` : `flex-direction: row;`)}
  flex-wrap: wrap;

    ${({ error }) =>
        error &&
        `
      border-top: 1px solid ${colors.red};
      padding-top: 0;
    `}
`

const Selectable = styled.button`
    ${({ borderColor }) => (borderColor ? `border: 1px solid ${borderColor};` : `border: 1px solid ${colors.greylight};`)}
    border-radius: 3px;
    cursor: pointer;
    margin-right: 5px;
    outline: none;
    padding: 4px 0;
    transition: all 0.3s;

    ${({ size }) => {
        switch (size) {
            case 'sm':
                return 'min-width: 50px;'
            case 'md':
                return 'min-width: 110px;'
            default:
                return ''
        }
    }}

    &:not(:first-child) {
        ${({ column }) => column && `margin-top: 5px;`}
    }

    &:hover {
        border: 1px solid ${colors.grey};
    }

    ${({ selected }) =>
        selected
            ? `
        background: ${colors.greylightest};
        border: 1px solid ${colors.grey};
        color: ${colors.bluedark};
        font-weight: bold;
      `
            : `
        background: ${colors.white};
        color: ${colors.grey};
        ${({ borderColor }) => borderColor && `border: 1px solid ${borderColor};`}
        ${({ borderColor }) => !borderColor && `border: 1px solid ${colors.greylight};`}
      `}
`

class Multiple extends PureComponent {
    static propTypes = {
        error: PropTypes.bool,
        inline: PropTypes.bool,
        name: PropTypes.string,
        size: PropTypes.oneOf(['sm', 'md']),
        value: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
        values: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.node,
                value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            })
        ),
        onChange: PropTypes.func,
        onlyOne: PropTypes.bool,
        column: PropTypes.bool,
        borderColor: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
        t: PropTypes.func.isRequired,
    }

    static defaultProps = {
        error: false,
        inline: false,
        onlyOne: false,
        column: false,
        name: '',
        size: 'md',
        value: [],
        values: [],
        onChange: () => null,
        borderColor: null,
    }

    constructor(props, ref) {
        super(props)

        this.ref = ref

        this.onClick = this.onClick.bind(this)
    }

    onClick(val) {
        const { name, onChange, value, onlyOne } = this.props

        let newValue = []
        // Deletes or inserts the new value into the array
        if (!onlyOne) newValue = value.includes(val) ? value.filter((v) => v !== val) : [...value, val]
        else newValue = val

        onChange({ target: { name, value: newValue } })
    }

    render() {
        const { error, inline, name: inputName, size, value, values, column, t, borderColor } = this.props

        const itemNameFormat = (name) => (typeof name === 'string' ? t(name) : name)

        return (
            <Wrapper name={inputName} error={error} column={column} inline={inline}>
                {values.map(({ name, value: val }) => (
                    <Selectable
                        type="button"
                        key={val}
                        onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            this.onClick(val)
                        }}
                        selected={value.includes(val)}
                        size={size}
                        column={column}
                        borderColor={borderColor}
                    >
                        {itemNameFormat(name)}
                    </Selectable>
                ))}
            </Wrapper>
        )
    }
}

export default withTranslation()(Multiple)
